import { mutations, getters, actions } from '@js/configs/ratesTableMethods'

const ratesTableModule = {
    state: {
        loanPurpose: {
            value: null,
        },
        loanAmount: {
            value: null,
        },
        creditRating: {
            value: null,
        },
        state: {
            value: null,
        },
        mappings: {
            creditRatings: [
                { name: 'Excellent 781 - 850', value: 1 },
                { name: 'Good 661 - 780', value: 2 },
                { name: 'Fair 601 - 660', value: 3 },
                { name: 'Poor 300 to 600', value: 4 },
            ],
            homeStatus: [
                { name: 'Yes', value: 1 },
                { name: 'No', value: 2 },
            ],
        },
        searching: false,
        sortOptionLists: {
            default: [
                { name: 'ratesTable.sorting.apr', field: 'rep_apr', active: true },
                { name: 'ratesTable.sorting.loanAmount', field: 'loan_range.min', active: false },
                { name: 'ratesTable.sorting.term', field: 'term_range.min', active: false },
            ],
            creditCardOnly: [
                { name: 'ratesTable.sorting.apr', field: 'rep_apr', active: true },
                { name: 'ratesTable.sorting.creditLimit', field: 'loan_range.max', active: false, descending: true },
                { name: 'ratesTable.sorting.promoDuration', field: 'promo_offer', active: false, descending: true },
            ],
        },
    },
    mutations,
    getters,
    actions,
}

export default ratesTableModule
